import React, { useEffect } from "react";
import { Card, CardBody, Col, Row } from "reactstrap";
import { useGebruikerContext } from "../../Context/GebruikerContext";

const Contactgegevens = () => {
	const { userDetails } = useGebruikerContext();
    const data = userDetails?.profileList;
    
	return (
		<>
			<Card className="main-card">
				<CardBody>
					<Row className="gap-20">
						<Col className="col-xxl-4 col-12 d-flex align-items-center justify-content-center mt-xxl-0">
							<div>
								<div className="user-img mx-auto">
									<div className="img-box">
										<img src={data?.profileImage} alt="img" />
									</div>
								</div>
								<p className="fw-bold mt-2 fs-18 text-center">
									{data?.vLastName} {data?.firstName} {data?.vMiddleName}
								</p>
							</div>
						</Col>
						<Col className="col-xxl-7 col-12">
							<h5 className="mb-4">Contactgegevens</h5>
							<Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
								<Col className="col-md-6 mt-0">Mobiele telefoon</Col>
								<Col className="col-md-6 mt-0">
									<span className="text-break">{data?.iMobileNumber}</span>
								</Col>
							</Row>
							<Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
								<Col className="col-md-6 mt-0">E-mail privé</Col>
								<Col className="col-md-6 mt-0">
									<span>{data?.vEmail}</span>
								</Col>
							</Row>
							<Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
								<Col className="col-md-6 mt-0">Telefoon privé</Col>
								<Col className="col-md-6 mt-0">
									<span className="text-break">{data?.vPhonePrivate}</span>
								</Col>
							</Row>
							<Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
								<Col className="col-md-6 mt-0">E-mail werk</Col>
								<Col className="col-md-6 mt-0">
									<span>{data?.vBusinessEmail}</span>
								</Col>
							</Row>
							<Row className="mb-4 mt-1 d-flex justify-content-between align-items-center">
								<Col className="col-md-6 mt-0">Telefoon werk</Col>
								<Col className="col-md-6 mt-0">
									<span>{data?.vPhoneWork}</span>
								</Col>
							</Row>
						</Col>
					</Row>
				</CardBody>
			</Card>
		</>
	);
};

export default Contactgegevens;
